
<template>
    
    <div>

        <label class="label w-100 mt-2">{{ $t('passwordFields.password') }}</label>
        <input type="password" autocomplete="current-password" v-model="UserDetails.Password" class=" w-100 mt-2" />

        <label class="label w-100 mt-2">{{ $t('settings.confirmPassword') }}</label>
        <input type="password" autocomplete="new-password" v-model="UserDetails.ConfirmPassword" class=" w-100 mt-2" />

        <p v-if="UserDetails.Password.length > 0 && UserDetails.PasswordsMatch == false" class="color-red">
            {{ $t('settings.passwordsDontMatch') }}
        </p>
        <p v-else-if="UserDetails.Password.length > 0 && UserDetails.PasswordValid == false" class="color-red">
            {{ $t('settings.passwordCriteria') }}
        </p>
        <p v-else-if="typeof UserDetails.Email != 'undefined' && UserDetails.Email.length == 0 && UserDetails.Password.length == 0" class="color-red">
            {{ $t('settings.emailMayNotBeEmpty') }}
        </p>
        <p v-else-if="UserDetails.Password.length == 0 && UserDetails.ConfirmPassword.length == 0" class="color-red">
            {{ $t('passwordFields.fillPasswordPlease') }}
        </p>
    </div>
</template>

<script>
    import { validatePassword } from "@/scripts/General.js"

    export default {
        name: 'PasswordFields',
        props: ['value'],


        data: function () {

            return {
                UserDetails: this.value,
            }

        },
        mounted: function () {

        },
        methods: {

        },
        watch: {
			UserDetails: function (newValue) {
                this.$emit('input', newValue)
            },
            value: function (newValue) {
				this.UserDetails = newValue
            },
            passwordsMatch: function (newValue) {
                this.UserDetails.PasswordsMatch = newValue
            },
			validatePassword: function (newValue) {
				this.UserDetails.PasswordValid = newValue
			},
        },
        computed: {
			passwordsMatch: function () {
				if (this.UserDetails.Password != this.UserDetails.ConfirmPassword) {
					return false
				} else {
					return true
				}

			},
			validatePassword: function () {
				return validatePassword(this.UserDetails.Password)
			}
        }
    }
</script>
